import { css, styled } from '@volkswagen-onehub/components-core';

export const ScreenreaderOnlyWrapper = styled.div`
  position: absolute;
  top: -100vh;
  left: -100vw;
`;

const clearClickAreaSize = 44;
const clearIconSize = 24;
const clearIconOffset = (clearClickAreaSize - clearIconSize) / 2;

export const transform = css`
  transform:
    translateY(${({ theme }) => theme.size.static250})
    translateY(${({ theme }) => theme.size.static100})
    translateY(${({ theme }) => parseInt(theme.size.static300) / 2}px)
    translateY(-50%)
  ;
`;

export const StyledClearButton = styled.button`
  position: relative;
  width: ${clearClickAreaSize}px;
  height: ${clearClickAreaSize}px;
  transform: translateX(
		${({ theme }) => theme.direction === 'rtl'
    ? `-${clearIconOffset}px`
    : `${clearIconOffset}px`}
	);
  background: transparent;
  padding: 0;
  border: none;
  line-height: 0;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  border-bottom: 1px solid transparent;
  border-radius: 50%;
  outline: none;
  -webkit-appearance: none;
  pointer-events: initial;
  color: ${({ disabled, theme }) => theme.colors.content[disabled ? 'disabled' : 'active']};
  ${({ disabled, theme }) => !disabled && css`
    :hover {
      ::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 50%;
        width: 100%;
        height: 100%;
        background-color: ${theme.colors.hoverIndicator};
        box-shadow: 0 0 0 ${theme.colors.hoverIndicator};
      }
    }
    :focus {
      background: ${theme.colors.focus.accent};
      color: ${theme.colors.content.inverted};
      border: 2px solid ${theme.colors.border.hover};
      outline: 0;
    }
  `}
`;

export const StyledClearButtonWrapper = styled.div`
  position: absolute;
  right: 0;
  left: 0;
  top: 0;
  pointer-events: none;
  display: flex;
  flex-direction: row-reverse;
  ${transform}
`;
